import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';
import PageHeader from '../../components/PageHeader';
import { Trophy, BookOpen, Calendar, ArrowRight, Search, ArrowUpDown } from 'lucide-react';
// Mock data for recent activity table
const recentActivityData = [{
  id: 1,
  type: 'Prove',
  description: 'Prova inviata',
  user: 'Marco Rossi',
  date: '2 ore fa',
  status: 'In revisione'
}, {
  id: 2,
  type: 'Sondaggi',
  description: 'Sondaggio pubblicato: Preferenze mobilità',
  user: '—',
  date: '5 ore fa',
  status: 'Pubblicato'
}, {
  id: 3,
  type: 'Corsi',
  description: 'Corso aggiornato: Zero Waste 101',
  user: '—',
  date: '1 giorno fa',
  status: 'Aggiornato'
}, {
  id: 4,
  type: 'Challenge',
  description: 'Challenge completata',
  user: 'Giulia Bianchi',
  date: '1 giorno fa',
  status: 'Completata'
}, {
  id: 5,
  type: 'Eventi',
  description: 'Evento creato: Workshop Compostaggio',
  user: '—',
  date: '2 giorni fa',
  status: 'Creato'
}];
// Mock data for upcoming events
const upcomingEvents = [{
  id: 1,
  title: 'Workshop Compostaggio',
  date: '15 Maggio, 18:00',
  location: 'Milano, Green Hub'
}, {
  id: 2,
  title: 'Meetup Community',
  date: '22 Maggio, 19:30',
  location: 'Roma, Eco Space'
}];
const LMSOverview = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [typeFilter, setTypeFilter] = useState('Tutto');
  const [statusFilter, setStatusFilter] = useState('Tutto');
  // Filter activity data
  const filteredActivity = recentActivityData.filter(activity => {
    const matchesSearch = activity.description.toLowerCase().includes(searchQuery.toLowerCase()) || activity.user.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesType = typeFilter === 'Tutto' || activity.type === typeFilter;
    const matchesStatus = statusFilter === 'Tutto' || activity.status === statusFilter;
    return matchesSearch && matchesType && matchesStatus;
  });
  return <div className="flex h-screen bg-gray-50" data-id="element-2292">
      <div className="w-20 flex-shrink-0" data-id="element-2293">
        <Sidebar data-id="element-2294" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-2295">
        <Topbar data-id="element-2296" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-2297">
          <PageHeader title="Panoramica LMS & Community" subtitle="Dashboard sintetica del modulo" data-id="element-2298" />

          {/* Stats Grid - Reordered: Corsi, Challenge, Eventi */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-2299">
            {/* Corsi pubblicati */}
            <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2300">
              <div className="flex items-center justify-between mb-4" data-id="element-2301">
                <div className="p-3 bg-gray-50 rounded-lg" data-id="element-2302">
                  <BookOpen className="h-6 w-6 text-gray-400" data-id="element-2303" />
                </div>
                <span className="text-3xl font-bold text-gray-900" data-id="element-2304">8</span>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-1" data-id="element-2305">
                Corsi pubblicati
              </h3>
              <p className="text-sm text-gray-500 mb-4" data-id="element-2306">
                Moduli formativi disponibili
              </p>
              <button onClick={() => navigate('/lms/corsi')} className="text-sm font-medium text-green-600 hover:text-green-700 flex items-center" data-id="element-2307">
                Gestisci corsi <ArrowRight className="h-4 w-4 ml-1" data-id="element-2308" />
              </button>
            </div>

            {/* Challenge attive */}
            <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2309">
              <div className="flex items-center justify-between mb-4" data-id="element-2310">
                <div className="p-3 bg-gray-50 rounded-lg" data-id="element-2311">
                  <Trophy className="h-6 w-6 text-gray-400" data-id="element-2312" />
                </div>
                <span className="text-3xl font-bold text-gray-900" data-id="element-2313">4</span>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-1" data-id="element-2314">
                Challenge attive
              </h3>
              <p className="text-sm text-gray-500 mb-4" data-id="element-2315">
                Sfide in corso per gli utenti
              </p>
              <button onClick={() => navigate('/lms/programmazione')} className="text-sm font-medium text-green-600 hover:text-green-700 flex items-center" data-id="element-2316">
                Gestisci challenge <ArrowRight className="h-4 w-4 ml-1" data-id="element-2317" />
              </button>
            </div>

            {/* Prossimo evento */}
            <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2318">
              <div className="flex items-center justify-between mb-4" data-id="element-2319">
                <div className="p-3 bg-gray-50 rounded-lg" data-id="element-2320">
                  <Calendar className="h-6 w-6 text-gray-400" data-id="element-2321" />
                </div>
                <span className="text-3xl font-bold text-gray-900" data-id="element-2322">
                  {upcomingEvents.length}
                </span>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-1" data-id="element-2323">
                Prossimo evento
              </h3>
              {upcomingEvents.length > 0 ? <>
                  <p className="text-sm text-gray-500 mb-4" data-id="element-2324">
                    {upcomingEvents[0].title}
                  </p>
                  <div className="text-xs text-gray-500 mb-4" data-id="element-2325">
                    {upcomingEvents[0].date} • {upcomingEvents[0].location}
                  </div>
                </> : <p className="text-sm text-gray-500 mb-4" data-id="element-2326">
                  Nessun evento in programma
                </p>}
              <button onClick={() => navigate('/lms/programmazione')} className="text-sm font-medium text-green-600 hover:text-green-700 flex items-center" data-id="element-2327">
                Vedi tutti <ArrowRight className="h-4 w-4 ml-1" data-id="element-2328" />
              </button>
            </div>
          </div>

          {/* Recent Activity Table */}
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2329">
            <div className="px-6 py-4 border-b border-gray-200" data-id="element-2330">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2331">
                Attività recente
              </h3>

              {/* Filters */}
              <div className="flex flex-col md:flex-row gap-4" data-id="element-2332">
                <div className="relative flex-1" data-id="element-2333">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-2334" />
                  <input type="text" placeholder="Cerca per utente o contenuto..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent text-sm" data-id="element-2335" />
                </div>
                <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent text-sm" data-id="element-2336">
                  <option value="Tutto" data-id="element-2337">Tipo: Tutto</option>
                  <option value="Prove" data-id="element-2338">Prove</option>
                  <option value="Sondaggi" data-id="element-2339">Sondaggi</option>
                  <option value="Corsi" data-id="element-2340">Corsi</option>
                  <option value="Challenge" data-id="element-2341">Challenge</option>
                  <option value="Eventi" data-id="element-2342">Eventi</option>
                </select>
                <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent text-sm" data-id="element-2343">
                  <option value="Tutto" data-id="element-2344">Stato: Tutto</option>
                  <option value="Inviata" data-id="element-2345">Inviata</option>
                  <option value="In revisione" data-id="element-2346">In revisione</option>
                  <option value="Approvata" data-id="element-2347">Approvata</option>
                  <option value="Non valida" data-id="element-2348">Non valida</option>
                  <option value="Pubblicato" data-id="element-2349">Pubblicato</option>
                  <option value="Aggiornato" data-id="element-2350">Aggiornato</option>
                  <option value="Creato" data-id="element-2351">Creato</option>
                  <option value="Completata" data-id="element-2352">Completata</option>
                </select>
              </div>
            </div>

            {/* Table */}
            {filteredActivity.length > 0 ? <div className="overflow-x-auto" data-id="element-2353">
                <table className="w-full" data-id="element-2354">
                  <thead className="bg-gray-50" data-id="element-2355">
                    <tr data-id="element-2356">
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2357">
                        <button className="flex items-center gap-1 hover:text-gray-700" data-id="element-2358">
                          Tipo <ArrowUpDown className="h-3 w-3" data-id="element-2359" />
                        </button>
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2360">
                        Descrizione
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2361">
                        Utente
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2362">
                        <button className="flex items-center gap-1 hover:text-gray-700" data-id="element-2363">
                          Data <ArrowUpDown className="h-3 w-3" data-id="element-2364" />
                        </button>
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2365">
                        Stato
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2366">
                        Azione
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-2367">
                    {filteredActivity.map(activity => <tr key={activity.id} className="hover:bg-gray-50" data-id="element-2368">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2369">
                          {activity.type}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900" data-id="element-2370">
                          {activity.description}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2371">
                          {activity.user}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2372">
                          {activity.date}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-2373">
                          <span className="px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-700" data-id="element-2374">
                            {activity.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm" data-id="element-2375">
                          <button className="text-green-600 hover:text-green-700 font-medium" data-id="element-2376">
                            Apri
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div> : <div className="px-6 py-12 text-center" data-id="element-2377">
                <p className="text-gray-500 mb-2" data-id="element-2378">
                  Nessuna attività da mostrare.
                </p>
                {(searchQuery || typeFilter !== 'Tutto' || statusFilter !== 'Tutto') && <button onClick={() => {
              setSearchQuery('');
              setTypeFilter('Tutto');
              setStatusFilter('Tutto');
            }} className="text-sm text-green-600 hover:underline" data-id="element-2379">
                    Rimuovi filtri
                  </button>}
              </div>}
          </div>
        </main>
      </div>
    </div>;
};
export default LMSOverview;